"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGlobalLocalization = void 0;
const react_1 = require("react");
const GlobalLocalizationContext_1 = require("./GlobalLocalizationContext");
const useGlobalLocalization = () => {
    let context = (0, react_1.useContext)(GlobalLocalizationContext_1.GlobalLocalizationContext);
    if (typeof context === 'undefined')
        throw Error('GlobalLocalizationContext is required');
    return context;
};
exports.useGlobalLocalization = useGlobalLocalization;
//# sourceMappingURL=useGlobalLocalization.js.map